import { atom } from "jotai";

interface AsyncRxCarePlanPreviewState {
  open: boolean;
  carePlanIds: string[];
}

export const asyncRxCarePlanPreviewAtom = atom<AsyncRxCarePlanPreviewState>({
  open: false,
  carePlanIds: [],
});
